/**
 * PhotoStripCapture — canonical name for the booth's photo-strip
 * capture flow. Explicit import + default re-export so the bundler
 * resolves the symbol deterministically (the bare `export { default }
 * from` form was the root cause of the P4 idle-attract crash —
 * preventing the same class of failure here pre-emptively).
 */
import BoothPhotoStrip from './BoothPhotoStrip';
export default BoothPhotoStrip;
